import { render, staticRenderFns } from "./VerifikasiUser.vue?vue&type=template&id=22361a45"
import script from "./VerifikasiUser.vue?vue&type=script&lang=js"
export * from "./VerifikasiUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports